

jQuery(document).ready(function($){

!function(r){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=r(require("jquery")):r(jQuery)}(function(r){"use strict";var t={bgVertical:function(r,t){return r.css({"background-position":"center "+-t+"px"})},bgHorizontal:function(r,t){return r.css({"background-position":-t+"px center"})},vertical:function(r,t,o){return"none"!==o||(o=""),r.css({"-webkit-transform":"translateY("+t+"px)"+o,"-moz-transform":"translateY("+t+"px)"+o,transform:"translateY("+t+"px)"+o,transition:"transform linear","will-change":"transform"})},horizontal:function(r,t,o){return"none"!==o||(o=""),r.css({"-webkit-transform":"translateX("+t+"px)"+o,"-moz-transform":"translateX("+t+"px)"+o,transform:"translateX("+t+"px)"+o,transition:"transform linear","will-change":"transform"})}},o={factor:function(r,t,o){var n=r.data("paroller-factor"),a=n||o.factor;if(t<576){var e=r.data("paroller-factor-xs"),i=e||o.factorXs;return i||a}if(t<=768){var c=r.data("paroller-factor-sm"),f=c||o.factorSm;return f||a}if(t<=1024){var l=r.data("paroller-factor-md"),u=l||o.factorMd;return u||a}if(t<=1200){var s=r.data("paroller-factor-lg"),d=s||o.factorLg;return d||a}if(t<=1920){var g=r.data("paroller-factor-xl"),h=g||o.factorXl;return h||a}return a},bgOffset:function(r,t){return Math.round(r*t)},transform:function(r,t,o,n){return Math.round((r-o/2+n)*t)}},n={background:function(r){return r.css({"background-position":"unset"})},foreground:function(r){return r.css({transform:"unset",transition:"unset"})}};r.fn.paroller=function(a){var e=r(window).height(),i=r(document).height(),a=r.extend({factor:0,factorXs:0,factorSm:0,factorMd:0,factorLg:0,factorXl:0,type:"background",direction:"vertical"},a);return this.each(function(){var c=r(this),f=r(window).width(),l=c.offset().top,u=c.outerHeight(),s=c.data("paroller-type"),d=c.data("paroller-direction"),g=c.css("transform"),h=s||a.type,p=d||a.direction,b=o.factor(c,f,a),m=o.bgOffset(l,b),v=o.transform(l,b,e,u);"background"===h?"vertical"===p?t.bgVertical(c,m):"horizontal"===p&&t.bgHorizontal(c,m):"foreground"===h&&("vertical"===p?t.vertical(c,v,g):"horizontal"===p&&t.horizontal(c,v,g)),r(window).on("resize",function(){var s=r(this).scrollTop();f=r(window).width(),l=c.offset().top,u=c.outerHeight(),b=o.factor(c,f,a),"background"===h?n.background(c):"foreground"===h&&s<=i&&n.foreground(c),m=Math.round(l*b),v=Math.round((l-e/2+u)*b),"background"===h?(n.background(c),"vertical"===p?t.bgVertical(c,m):"horizontal"===p&&t.bgHorizontal(c,m)):"foreground"===h&&s<=i&&(n.foreground(c),"vertical"===p?t.vertical(c,v):"horizontal"===p&&t.horizontal(c,v))}),r(window).on("scroll",function(){var o=r(this).scrollTop();i=r(document).height(),m=Math.round((l-o)*b),v=Math.round((l-e/2+u-o)*b),"background"===h?"vertical"===p?t.bgVertical(c,m):"horizontal"===p&&t.bgHorizontal(c,m):"foreground"===h&&o<=i&&("vertical"===p?t.vertical(c,v,g):"horizontal"===p&&t.horizontal(c,v,g))})})}});

	function CallOwlProductCarousel(selector){
		$(selector).owlCarousel({
		    loop:true,
		    margin:20,
		    nav:false,
		    items:3,
		    dots:false,
		    autoplay:true,
		    autoplayTimeout:6000,
		    responsiveClass:true,
		   	nav:true,
		    navText : ['<i class="leftArrow arrowSlider"></i>','<i class="rightArrow arrowSlider"></i>'],
		    responsive:{
		        300:{items:1},
		        600:{items:2},
		        900:{items:3}
		    }
		});
	}


	$.fn.textWidth = function(){
		  var sensor = $('<div />').css({margin: 0, padding: 0});
		  $(this).append(sensor);
		  var width = sensor.width();
		  sensor.remove();
		  return width;
		};


	$(document).on('click', '.call-gallery', function(event) {
		event.preventDefault();
		$(this).siblings(".hidden").find( "a:first-child" ).trigger( "click" );
	});

	$(document).on('click', '#pharmacyForm h2.forOpen', function(event) {
		event.preventDefault();
		$(this).toggleClass("open").siblings("table").slideToggle(400);
	});

	$(document).on('click', '.searchButton', function(event) {
		event.preventDefault();
		$("#searchForm").slideToggle(600);
	});

	if($(".flx-team-carousel .owl-carousel").length) {
  		$('.flx-team-carousel .owl-carousel').owlCarousel({
		    loop:true,
		    margin:0,
		    items:1,
		    nav:true,
		    navText : ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
		    responsiveClass:true,
		    responsive:{
		        0:{items:1},
		        600:{items:3}
		    }
		});
	}


	if($(".flx-picture-grid .owl-carousel").length) {
  		$('.flx-picture-grid .owl-carousel').owlCarousel({
		    loop:true,
		    margin:20,
		    nav:false,
		    items:1,
		    dots:true,
		    autoplay:true,
		    autoplayTimeout:2000,
		    responsiveClass:true,
		    responsive:{
		        0:{items:1},
		        300:{items:2},
		        600:{items:3},
		        900:{items:4},
		        1200:{items:5}
		    }
		});
	}



	if($(".triggerForPosterCarousel .owl-carousel").length) {
  		$('.triggerForPosterCarousel .owl-carousel').owlCarousel({
		    loop:true,
		    margin:20,
		    nav:true,
		    items:1,
		    dots:false,
		    autoplay:true,
		    autoplayTimeout:3000,
		    responsiveClass:true,
		    smartSpeed: 1000
		});
	}




	if($(".triggerForOwl.productsCarousel").length) {
		CallOwlProductCarousel('.triggerForOwl.productsCarousel');
	}

	if($("#carouselx3").length) {
		CallOwlProductCarousel('#carouselx3 .owl-carousel');
	}

	if($(".flx-slider .owl-carousel").length) {

		function ShowText(){
		   setTimeout(
			  function()
			  {
			    $('.flx-slider .owl-carousel .active .text').each(function(index, el) {
			    	$(".flx-slider .owl-carousel .text[data-transition='fade']").css('opacity', '0');
		   			$(".flx-slider .owl-carousel .text[data-transition='slide in']").css('margin-left', '-150%');
			   		transition = 'fade';
			   		delay = '100';
			   		opacity = '0.9';
			   		margin_x ='0';

			   		if(transition=="fade")
			   		{
			   			$(this).show(0).delay(delay).animate({ 'opacity': opacity}, 500);
			   		}
			   		else
			   		{
			   			$(this).show(0).delay(delay).animate({ 'marginLeft': margin_x+'%'}, 500);
			   		}
			    });
			}, 50);
		}

  		$('.flx-slider .owl-carousel').owlCarousel({
		    loop:true,
		    margin:0,
		    nav:true,
		    items:1,
		    dots:true,
		    autoplay:true,
		    autoplayTimeout:7000,
		    smartSpeed: 1000
		});
		ShowText();

		$('.flx-slider .owl-carousel').on('changed.owl.carousel', function(event) {
		   $('.flx-slider .owl-carousel .text').hide();
		   ShowText();
		});
	}

	if($(".flx-readmore").length) {
			var readMore = 'Mehr';
			var readLess = 'Weniger';
			var link = "<a href='' class='readMore'>"+readMore+"</a>";

		$(".flx-readmore").each(function(index, el) {
			var height = $(this).attr('data-flx-readmore-height');
			var content = $(this).find(".content");

			if(!(height>0)) height=200;

			content.height(height);
			$(link).insertAfter(content);
		});

		$(document).on('click', '.flx-readmore .readMore', function(event) {
			event.preventDefault();		;
			$(this).text(readLess).toggleClass('readMore').toggleClass('readLess').siblings('.content').height('');
		});

		$(document).on('click', '.flx-readmore .readLess', function(event) {
			event.preventDefault();
			var height = $(this).closest('.flx-readmore').attr('data-flx-readmore-height');
			if(!(height>0)) height=200;
			$(this).text(readMore).toggleClass('readMore').toggleClass('readLess').siblings('.content').height(height);
		});
	}

	if($("address").length) {

        $("address").each(function(){
             var embed ="<iframe style='width:100%;height:600px;' frameborder='0' scrolling='no' marginheight='0' marginwidth='0'  src='https://maps.google.com/maps?&amp;q="+
              encodeURIComponent( $(this).text() ) +"&amp;output=embed'></iframe>";
             $(this).html(embed);
       });
	}
	$("#38-h-2, #24-2").remove();

	if($(".my-paroller").length) {

 		$('.my-paroller').paroller();
	}

	$(document).on('click', '.hamburger', function(event) {
		event.preventDefault();
		$(this).toggleClass('change');
		$(".menuContainer").toggleClass('open');
		$("body").toggleClass('menuOpen');
	});





	if($(".sameHeight").length) {
		setTimeout(function (){

			$('.sameHeight').each(function(){
		      var highestBox = 0;
		      $('.sameHeightChildren', this).each(function(){
		        if($(this).height() > highestBox) {
		          highestBox = $(this).height();
		        }
		      });
		      highestBox = highestBox + 0;
		      $('.sameHeightChildren',this).height(highestBox);
		    });

		}, 500);

	}


	if(!($(".home").length)) {
		$( "#menu-primary li a" ).each(function( index ) {
		  var link = $(this).attr('href');
		  link = "http://"+window.location.hostname + link;
		  $(this).attr('href', link);
		});
	}


	if($(".home").length) {
		$('#menu-primary').onePageNav({
			currentClass: 'current',
			changeHash: false,
			scrollSpeed: 750,
			scrollThreshold: 0.5,
			filter: '',
			easing: 'swing',
			begin: function() {
				//I get fired when the animation is starting
			},
			end: function() {
				//I get fired when the animation is ending
			},
			scrollChange: function($currentListItem) {
				//I get fired when you enter a section and I pass the list item of the section
			}
		});

	}

	$(document).on('click', '.imageSingle a[href^="#"]', function(e) {
	    var id = $(this).attr('href');
	    id = id.replace("-2", "");
	    var $id = $(id);
	    e.preventDefault();
	    var pos = $id.offset().top - 175;
	    $('body, html').animate({scrollTop: pos});
	});

	$(document).on('click', '.goToTop', function(e) {
	    //var a_href = $(this).closest('.myBorder').attr('id');
	    //var $a_href = $('a[href="#'+a_href+'"]');
	    e.preventDefault();
	    var pos = $(".flx-gallery").offset().top - 100;
	    $('body, html').animate({scrollTop: pos});
	});

    $(window).scroll( function(){

        /* Check the location of each desired element */
        $('.hideme').each( function(i){

            var bottom_of_object = $(this).offset().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();


			if (window.matchMedia("(max-width: 700px)").matches) {

            	if( bottom_of_window > bottom_of_object-450 )
            	{

	                $(this).animate({'opacity':'1'},500);
	                $(this).find('img').animate({'opacity':'1'},800);
	                $(this).find('h3').animate({'opacity':'1'},1200);
	                $(this).find('h2').animate({'opacity':'1'},1600);
	                $(this).find('p').animate({'opacity':'1'},2000);

	            }

			}
			else
			{
				if( bottom_of_window > bottom_of_object-150 ){

						$(this).animate({'opacity':'1'},500);
						$(this).find('img').animate({'opacity':'1'},800);
						$(this).find('h3').animate({'opacity':'1'},1200);
						$(this).find('h2').animate({'opacity':'1'},1600);
						$(this).find('p').animate({'opacity':'1'},2000);

				}
			}

        });

    });

});

jQuery(document).ready(function($) {
	$('.iframe-holder').prepend('<iframe src="https://map.apotheken-helfen.digitale-apotheke.com" id="map-holder"></iframe>');

	$.fn.isOnScreen = function(){

	    var win = $(window);

	    var viewport = {
	        top : win.scrollTop(),
	        left : win.scrollLeft()
	    };
	    viewport.right = viewport.left + win.width();
	    viewport.bottom = viewport.top + win.height();

	    var bounds = this.offset();
	    bounds.right = bounds.left + this.outerWidth();
	    bounds.bottom = bounds.top + this.outerHeight();

	    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	};

	$(window).scroll(function(){
        if ($('.iframe-holder').isOnScreen()) {
					var myUrl = $('#map-holder').attr('src');
					if(!(myUrl.includes("#")))
						$('#map-holder').attr('src', myUrl + "#play");
        }
    });
		$(window).scroll();
});
